export default "__VITE_ASSET__E7y7DEXy__"